// Onboarding title picks — shared by web and mobile.
//
// TMDB movie and TV ids are separate number spaces (movie 1399 and TV 1399
// are different titles), so a pick is identified by kind + id, never by the
// TMDB id alone.

/** Stable key for a picked title: `movie:603`, `tv:1399`. */
export function titleKey(kind, tmdbId) {
    return `${kind}:${Number(tmdbId)}`;
}

/**
 * Picks that can be offered on the "You're all set!" (choose a coin) step: a
 * movie or TV show with a usable TMDB id, each title once, in pick order.
 * Whether a quiz is ready right now is decided when the challenge starts (TV
 * seasons are checked on tap), exactly as before — this only removes picks
 * that could never start one.
 */
export function coinEligibleTitles(titles) {
    const seen = new Set();
    const out = [];
    for (const t of Array.isArray(titles) ? titles : []) {
        if (!t || (t.kind !== 'movie' && t.kind !== 'tv')) continue;
        const tmdbId = Number(t.tmdbId);
        if (!Number.isInteger(tmdbId) || tmdbId <= 0) continue;
        const key = titleKey(t.kind, tmdbId);
        if (seen.has(key)) continue;
        seen.add(key);
        out.push({ ...t, tmdbId });
    }
    return out;
}
